module.exports = __webpack_public_path__ + "static/media/install05.f357a7b0.png";